<script>
import UserAvatar from '@/components/user/user-avatar.vue'
import { mapGetters, mapActions } from 'vuex'
import baseMixin from '@mixins/baseMixin'

export default {
  name: 'NavDrawerProfile',
  components: {
    UserAvatar,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
      user: 'auth/currentUserSimple',
    }),
    fullName() {
      return (
        this.user?.fullName || this.$t('layout.profileDropdownDefaultUserName')
      )
    },
    sheetClasses() {
      return {
        'd-flex align-center': true,
        'flex-shrink-0': this.isMobileViewPort,
      }
    },
    currentlyLoggedInTooltipText() {
      if (this.mini) return ''
      return this.$t('layout.profileDropdownLoggedInTooltipText', {
        name: this.fullName,
      })
    },
    profileDetailsContainerClasses() {
      return {
        'd-flex align-center': true,
        'nav-btn-mini justify-center': this.mini,
        'justify-start py-2': !this.mini,
        'px-4': !this.isMobileViewPort,
        'px-2 mb-2': this.isMobileViewPort,
      }
    },
    profileNameClasses() {
      return {
        'ms-2 mb-0 text-small-button profile__name': true,
        'profile__name--mobile': this.isMobileViewPort,
      }
    },
    signOutLinkClasses() {
      return `text-caption-bold ${this.colorClass.text.grey600} ms-2 mb-0 w-fit-content`
    },
  },
  methods: {
    ...mapActions({
      logOut: 'auth/logOut',
    }),
    handleSignOut() {
      this.logOut({ redirect: true, nuke: true })
    },
  },
}
</script>

<template>
  <v-tooltip :disabled="!mini" right>
    <template v-slot:activator="{ on }">
      <v-sheet
        :class="sheetClasses"
        :width="!mini ? '80%' : ''"
        :title="currentlyLoggedInTooltipText"
      >
        <div :class="profileDetailsContainerClasses" v-on="on">
          <UserAvatar
            :class="isMobileViewPort ? 'mr-2' : ''"
            size="sm"
            :name="fullName"
            :badge="user.isImpersonating"
            badge-color="blue"
            badge-dot
            badge-offset-x="10"
            badge-offset-y="10"
          />
          <div class="d-flex flex-column">
            <p v-if="!mini" :class="profileNameClasses">{{ fullName }}</p>
            <!-- `title` is left intentionally blank so hoving over
                 the sign out link won't cause the title to appear -->
            <a
              v-if="!mini"
              title=""
              :class="signOutLinkClasses"
              @click="handleSignOut"
              >{{ $t('layout.signout') }}</a
            >
          </div>
        </div>
      </v-sheet>
    </template>
    <span>{{ fullName }}</span>
  </v-tooltip>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';

.profile__name {
  display: -webkit-box;
  width: 130px;
  overflow: hidden;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  &--mobile {
    width: 100% !important;
  }
}
</style>
